import { resolveHomepageSectionsImage } from '../../../../../helpers/construct/page-content.helper';
import { type BannerContent, type ContentComponent } from '../../../../../types/construct.types';
import { HomeBanner } from '../../../../home-components/home-banner/home-banner.component';

export const BannerHandler: ContentComponent<BannerContent> = ({
	content: {
		fields: { desktop, mobile, link }
	}
}) => {
	return (
		<HomeBanner
			desktop={resolveHomepageSectionsImage(desktop)}
			mobile={resolveHomepageSectionsImage(mobile)}
			link={{
				name: 'Link',
				url: link.linkUrl,
				tracking: link.trackingCode ?? ''
			}}
		/>
	);
};
